"use client";

import { useEffect } from "react";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

const primaryCtaClass =
  "inline-flex items-center justify-center gap-2 rounded-full bg-[#ee376a] px-6 py-3 text-sm font-semibold text-white shadow-[0_16px_34px_rgba(181,95,57,0.28)] transition hover:-translate-y-0.5 hover:shadow-[0_22px_44px_rgba(181,95,57,0.34)]";

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--background)] px-6">
      <div className="max-w-xl rounded-[2rem] border border-[var(--color-line)] bg-[var(--color-surface)] p-8 text-center shadow-[var(--shadow-soft)] backdrop-blur-sm">
        <p className="text-sm font-semibold tracking-[0.22em] text-[var(--color-ink-muted)] uppercase">
          Unexpected Error
        </p>
        <h1 className="mt-4 text-3xl font-semibold text-[var(--color-ink)]">
          حدث خطأ غير متوقع
        </h1>
        <p className="mt-4 text-base leading-8 text-[var(--color-ink-soft)]">
          الصفحة واجهت مشكلة مؤقتة. حاول إعادة المحاولة، وإذا استمرت المشكلة
          نقدر نراجع الجزء المرتبط بها.
        </p>
        <button type="button" onClick={reset} className={`${primaryCtaClass} mt-8`}>
          حاول مرة أخرى
        </button>
      </div>
    </div>
  );
}
